import { useEffect, useState } from "react";
import useDetectScrollState from "hooks/useDetectScrollState";
import { useZowiePositionStore } from "stores/ZowiePositionStore";
import { Global } from "@emotion/react";
import { isInViewport } from "./utils";

const bottomMargin = 16;

export const ZowieControl = () => {
  const scrollState = useDetectScrollState(50, 250);
  const [isOpenOnStart, setIsOpenOnStart] = useState(false);
  const { bottom } = useZowiePositionStore();

  useEffect(() => {
    const urlParams = new URLSearchParams(window.location.search);
    if (urlParams.get("data") === "chat") {
      setIsOpenOnStart(true);
    }
  }, []);

  useEffect(() => {
    const chatButton =
      document.getElementById("zowieFloatingButtonMobile") || document.getElementById("zowieFloatingButton");

    if (chatButton && isInViewport(chatButton)) {
      let timeoutId: ReturnType<typeof setTimeout>;
      const chatbotWrapper = document.getElementById("zowieChatbotWrapper");
      const isChatClosed = chatbotWrapper.style.visibility === "hidden";
      chatButton.style.bottom = `${bottom + bottomMargin}px`;

      if ((isChatClosed && scrollState === "down") || (isChatClosed && window.pageYOffset < 500)) {
        chatButton.style.opacity = "0";
        timeoutId = setTimeout(() => {
          chatButton.style.visibility = "hidden";
        }, 300);
        return;
      }

      clearTimeout(timeoutId);
      chatButton.style.visibility = "visible";
      chatButton.style.opacity = "1";
    }
  }, [scrollState, bottom]);

  return (
    <Global
      styles={{
        "#zowieFloatingButtonMobile, #zowieFloatingButton": {
          visibility: isOpenOnStart ? "initial" : "hidden",
          transition: "opacity 0.3s linear, bottom 0.3s ease",
        },
      }}
    />
  );
};
